import React, { useState } from 'react';
import { WithT } from 'i18next';
import { Col } from 'wix-style-react';

import s from './Menus.scss';
import { getLink } from '../../Content/links';

interface MobileMenuProps extends WithT {}

export const MobileMenu: React.FC<MobileMenuProps> = ({ t }) => {
  const [open, setOpen] = useState(false);

  return (
    <Col span={8} className={s.mobileMenuContainer}>
      <div
        className={`${s.mobileMenuIcon} ${open ? s.open : ''}`}
        onClick={() => setOpen(!open)}
      >
        <span />
        <span />
        <span />
      </div>
      <div className={`${s.mobileTopBarMenu} ${open ? s.open : ''}`}>
        <ul>
          <li className={s.topBarMenuItem}>
            <a href={getLink('editorXFeatures')} className={s.link}>
              {t('editorx.menu.features')}
            </a>
          </li>
          <li className={s.topBarMenuItem}>
            <a href={getLink('editorXTemplates')} className={s.link}>
              {t('editorx.menu.expressions')}
            </a>
          </li>
        </ul>
      </div>
    </Col>
  );
};
